import * as GoogleAddressTypes from './googleAddress.types';
import {
  IGoogleAddress,
  IinitialGoogleAddressState,
} from 'interfaces/googleAddress.interface';

export type TgoogleAddressDispatchReducer =
  | {
      type: typeof GoogleAddressTypes.SET_GOOGLE_ADDRESS;
      payload: {
        formKey: string;
        field: string;
        value: string | null;
      };
    }
  | {
      type: typeof GoogleAddressTypes.AUTO_SET_GOOGLE_ADDRESS;
      payload: {
        values: IGoogleAddress;
      };
    }
  | {
      type: typeof GoogleAddressTypes.RESET_GOOGLE_ADDRESS;
      payload: {
        formKey: string;
        values: IGoogleAddress | null;
      };
    };

export default function googleAddressReducer(
  state: IinitialGoogleAddressState,
  action: TgoogleAddressDispatchReducer
) {
  const { type, payload } = action;

  switch (type) {
    case GoogleAddressTypes.SET_GOOGLE_ADDRESS: {
      const updatedAddresses = state.googleAddresses.map((address) =>
        address.formKey === payload.formKey
          ? { ...address, [payload.field]: payload.value }
          : address
      );
      return { ...state, googleAddresses: updatedAddresses };
    }

    case GoogleAddressTypes.AUTO_SET_GOOGLE_ADDRESS: {
      const existingIndex = state.googleAddresses.findIndex(
        (address) => address.formKey === payload.values.formKey
      );

      if (existingIndex !== -1) {
        const updatedAddresses = [...state.googleAddresses];
        updatedAddresses[existingIndex] = payload.values;
        return { ...state, googleAddresses: updatedAddresses };
      }

      return { ...state, googleAddresses: [...state.googleAddresses, payload.values] };
    }

    case GoogleAddressTypes.RESET_GOOGLE_ADDRESS: {
      const updatedAddresses = state.googleAddresses.map((address) =>
        address.formKey === payload.formKey
          ? payload.values || {
              formKey: payload.formKey,
              address: '',
              postal_code: '',
              country_id: '',
              city: '',
              province: '',
              floor: '',
              door: '',
              coordinates: { lat: null, lng: null },
            }
          : address
      );
      return { ...state, googleAddresses: updatedAddresses };
    }

    default:
      return state;
  }
}
